<!-- 满意度 -->
<template>
  <div id="satisfaction" class="border-div" ></div>
</template>

<script>
  export default {
    name: "agentStatus",
    data() {
      return {

        satisfactionData: [{
            value: 0,
            name: "非常满意"
          },
          {
            value: 0,
            name: "满意"
          },
          {
            value: 0,
            name: "一般"
          },
          {
            value: 0,
            name: "服务态度不满意"
          },
          {
            value: 0,
            name: "处理结果不满意"
          }
        ], //满意度数据
        timeFlag: '',
        pieChart2:null,
      }
    },
    created() {
      this.getSatisfaction();
      this.timeFlag = setInterval(this.getSatisfaction, 5000);
    },
    methods: {
        // 满意度评价
      getSatisfaction() {
        let that = this;
        let param = {
          journalType: null,
          menuId: null
        };
        this.$http.post("bigScreen/toSatisfactionEvaluationIndex.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }

          that.satisfactionData = res.data.obj.list;
          that.handleBottomRightEchart(); // 右下饼图
        });
      },

      // 处理右下饼图
      handleBottomRightEchart() {
        let that = this;
        // 1.实例化对象
        that.pieChart2 = this.$echarts.init(
          document.getElementById("satisfaction")
        );
        // 2.把配置项给实例对象
        that.pieChart2.setOption({
          color: [
            "#0dc7fc",
            "#0578eb",
            "#57c48d",
            "#df910a",
            "#8d03b4",
          ],
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            // right: 5,
            right:30,
            y:'center',
            textStyle: {
              color: "rgba(255,255,255,.8)",
              fontSize: 16,
            }
          },
          series: [{
            name: "满意度评价",
            type: "pie",
            radius: ["30%", "60%"],
            center: ["30%", "50%"],
            roseType: "radius",
            label: {
              show: true,
              position: "inside",
              formatter: "{c}",
              fontSize:"16"
            },
            data: this.satisfactionData,
          }]
        });
        // 让图表跟随屏幕自动的去适应
        // window.addEventListener("resize", function () {
        //   pieChart2.resize();
        // });
      },

    },
    beforeDestroy() {
      if(this.timeFlag){
            clearInterval(this.timeFlag);
      }
      this.getSatisfaction = null;
      this.handleBottomRightEchart = null;
      this.pieChart2 = null;
      this.$echarts = null;

    },
    destroyed() {
        
      },

  }
</script>
<style scoped lang="less">
@import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/satisfaction.vue